import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'EditLink',
  props: {
    editStep: {},
    slug: {},
    route: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.editStep)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: __props.route, params: { slug: __props.slug, step: __props.editStep } },
        class: "edit-link absolute top-9 right-9 rounded-full border border-black w-10 h-10 flex justify-center items-center hover:bg-black hover:text-white transition-colors"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "material-icons" }, "edit", -1)
        ]))]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})